import { isFragment } from 'react-is';

const traverseFragment = (children) =>
  isFragment(children) ? children.props.children : children;

export default traverseFragment;
